module.exports = __webpack_public_path__ + "img/img6.dc05e698.png";